/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React, { useContext, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Deliveries from "views/deliveries";
import Dashboard from "views/dashboard";
import LoadingBayDispatch from "views/loadingBayDispatch";
import RoutesManagement from "views/routesManagement";
import StoreManagement from "views/storeManagement";
import VaultManagement from "views/vaultManagement";
import CreateDelivery from "views/createDelivery";
import Collections from "views/collections";
import CreateCollection from "views/createCollection";
import B2BServices from "views/b2bServices";
import CreateB2BService from "views/createB2BService";
import DeliveryDetail from "views/deliveryDetail";
import CollectionDetail from "views/collectionDetail";
import B2BServiceDetail from "views/b2bServiceDetail";
import AssetsManagement from "views/assetsManagement";
import FieldTeamManagement from "views/teamManagement";
import EndOfCashCenterDay from "views/endOfDay";
import ConsignmentsHandover from "views/consignmentsHandover";
import CreateHandoverRequest from "views/createConsignmentsHanover";
import WorkLoadAutomation from "views/workLoadManagement";
import Kiosk from "views/kiosk";
import CreateKiosk from "views/createKiosk";
import KioskDetail from "views/kioskDetail";
import ChangePassword from "views/changePassword";
import CitServicesReport from "views/reports/citServicesReport";
import CashCollectionsReport from "views/reports/cashCollectionsReport";
import CashDeliveriesReport from "views/reports/cashDeliveriesReport";
import Clearance from "views/clearance";
import CreateClearance from "views/createClearance";
import ClearanceDetail from "views/clearanceDetail";
import Replenishment from "views/replenishment";
import CreateReplenishment from "views/createReplenishment";
import ReplenishmentDetail from "views/replenishmentDetail";
import VaultDailyReport from "views/reports/vaultReport";
import SMTDashboardPage from "views/smtDashboard";
import CashierResidualsReport from "views/reports/cashierResidualsReport";
import CITFieldServicesDailyReport from "views/reports/citFieldServicesReport";
import FieldTeamDailyRoaster from "views/reports/roasterReport";
import CdmCollectionsReport from "views/reports/cdm/cdmCollectionsReport";
import CdmDiscrepanciesReport from "views/reports/cdm/cdmDiscrepanciesReport";
import CDMHistoryReport from "views/reports/cdm/cdmHistoryReport";
import CDMReconciliationReport from "views/reports/cdm/cdmReconciliationReport";
import CashierCassettesFillingReport from "views/reports/cashierCassettesFillingReport";
import ATMDiscrepanciesReport from "views/reports/atm/atmDiscrepanciesReport";
import ATMFieldServicesDailyReport from "views/reports/atmFieldServicesDailyReport";
import ATMHistoryReport from "views/reports/atm/atmHistoryReport";
import ATMReconciliationReport from "views/reports/atm/atmReconciliationReport";
import ATMReplenishmentReport from "views/reports/atm/atmReplenishmentsReport";
import ATMResidualsReport from "views/reports/atm/atmResidualsReport";
import { UserContext } from "utils/reducers/user";
import { saveFilters } from "utils/actions/user";
import ViewB2BOrder from "views/b2bServices/view-order";
import { LookUpContext } from "utils/reducers/lookup";
import {
  useGetAllBagTypes,
  useGetCoinContainers,
  useGetCurrenciesList,
} from "utils/apis/lookups.api";
import {
  setBagTypes,
  setCoinContainers,
  setCurrencyList,
} from "utils/actions/lookup";
import ManageAllOrders from "views/manageAllOrders";
import LoadingBayReceiving from "views/loadingBayReceiving";
import OrdersByLocation from "views/ordersByLocation";
import OrdersByRoutes from "views/ordersByRoute";
import PackageLifeCycle from "views/packageLifeCycle";
import DeliveryPackageVerification from "views/reRoutingPackageVerification";
import Exchange from "views/exchange";
import CreateExchange from "views/createExchange";
import ExchangeDetail from "views/exchangeDetail";
import InterBranch from "views/interBranch";
import InterBranchDetail from "views/interBranchDetail";
import CreateInterBranch from "views/createInterBranch";
import InterBranchManagement from "views/interBranchManagement";
import SplitRoute from "views/splitRoute";
import CreateSplitRoute from "views/createSplitRoute";
import SplitRouteManagement from "views/splitRouteManagement";
import CreateAllOrders from "views/createAllOrders";
import VehicleInsuranceLimitList from "views/vehicleInsuranceLimit";

const routes = [
  {
    path: "/change-password",
    Component: ChangePassword,
  },
  {
    path: "/dashboard",
    Component: Dashboard,
  },
  {
    path: "/deliveries",
    Component: Deliveries,
  },
  {
    path: "/create-delivery",
    Component: CreateDelivery,
  },
  {
    path: "/deliveries-detail",
    Component: DeliveryDetail,
  },
  {
    path: "/collections",
    Component: Collections,
  },
  {
    path: "/collections-detail",
    Component: CollectionDetail,
  },
  {
    path: "/create-collection",
    Component: CreateCollection,
  },
  {
    path: "/create-b2b-service",
    Component: CreateB2BService,
  },
  {
    path: "/b2b-services",
    Component: B2BServices,
  },
  {
    path: "/b2b-services-detail",
    Component: B2BServiceDetail,
  },
  {
    path: "/b2b-services-view-order",
    Component: ViewB2BOrder,
  },
  {
    path: "/create-exchange-service",
    Component: CreateExchange,
  },
  {
    path: "/exchange-services",
    Component: Exchange,
  },
  {
    path: "/exchange-services-detail",
    Component: ExchangeDetail,
  },
  {
    path: "/create-inter-branch-service",
    Component: CreateInterBranch,
  },
  {
    path: "/inter-branch-services",
    Component: InterBranch,
  },
  {
    path: "/inter-branch-services-detail",
    Component: InterBranchDetail,
  },
  {
    path: "/smt-dashboard",
    Component: SMTDashboardPage,
  },
  {
    path: "/routes",
    Component: RoutesManagement,
  },
  {
    path: "/store",
    Component: StoreManagement,
  },
  {
    path: "/vault",
    Component: VaultManagement,
  },
  {
    path: "/loading-bay-dispatch",
    Component: LoadingBayDispatch,
  },
  {
    path: "/loading-bay-receiving",
    Component: LoadingBayReceiving,
  },
  {
    path: "/inter-branch-management",
    Component: InterBranchManagement,
  },
  {
    path: "/create-all-service",
    Component: CreateAllOrders,
  },
  {
    Component: ManageAllOrders,
    path: "/manage-all-order",
  },
  {
    path: "/orders-by-location",
    Component: OrdersByLocation,
  },
  {
    path: "/orders-by-route",
    Component: OrdersByRoutes,
  },
  {
    path: "/package-life-cycle",
    Component: PackageLifeCycle,
  },
  {
    path: "/assets-management",
    Component: AssetsManagement,
  },
  {
    path: "/team-management",
    Component: FieldTeamManagement,
  },
  {
    path: "/end-of-day",
    Component: EndOfCashCenterDay,
  },
  {
    path: "/consignments-handover",
    Component: ConsignmentsHandover,
  },
  {
    path: "/create-consignments-handover",
    Component: CreateHandoverRequest,
  },
  {
    path: "/work-load-automation",
    Component: WorkLoadAutomation,
  },
  {
    path: "/delivery-packages-verification",
    Component: DeliveryPackageVerification,
  },
  {
    path: "/kiosk",
    Component: Kiosk,
  },
  {
    path: "/kiosk-detail",
    Component: KioskDetail,
  },
  {
    path: "/create-kiosk",
    Component: CreateKiosk,
  },
  {
    path: "/clearance",
    Component: Clearance,
  },
  {
    path: "/create-clearance",
    Component: CreateClearance,
  },
  {
    path: "/clearance-detail",
    Component: ClearanceDetail,
  },
  {
    path: "/replenishment",
    Component: Replenishment,
  },
  {
    path: "/create-replenishment",
    Component: CreateReplenishment,
  },
  {
    path: "/replenishment-detail",
    Component: ReplenishmentDetail,
  },
  {
    path: "/cit-report",
    Component: CitServicesReport,
  },
  {
    path: "/collection-report",
    Component: CashCollectionsReport,
  },
  {
    path: "/delivery-report",
    Component: CashDeliveriesReport,
  },
  {
    path: "/vault-report",
    Component: VaultDailyReport,
  },
  {
    path: "/cashier-residuals-report",
    Component: CashierResidualsReport,
  },
  {
    path: "/cashier-cassettes-filling-report",
    Component: CashierCassettesFillingReport,
  },
  {
    path: "/cit-field-services-report",
    Component: CITFieldServicesDailyReport,
  },
  {
    path: "/roster-report",
    Component: FieldTeamDailyRoaster,
  },
  {
    path: "/cdm-collection-report",
    Component: CdmCollectionsReport,
  },
  {
    path: "/cdm-discrepancies-report",
    Component: CdmDiscrepanciesReport,
  },
  {
    path: "/cdm-history-report",
    Component: CDMHistoryReport,
  },
  {
    path: "/cdm-reconciliation-report",
    Component: CDMReconciliationReport,
  },
  {
    path: "/atm-discrepancies-report",
    Component: ATMDiscrepanciesReport,
  },
  {
    path: "/atm-field-service-report",
    Component: ATMFieldServicesDailyReport,
  },
  {
    path: "/atm-history-report",
    Component: ATMHistoryReport,
  },
  {
    path: "/atm-reconciliation-report",
    Component: ATMReconciliationReport,
  },
  {
    path: "/atm-replenishment-report",
    Component: ATMReplenishmentReport,
  },
  {
    path: "/atm-residuals-report",
    Component: ATMResidualsReport,
  },
  {
    path: "/split-route",
    Component: SplitRoute,
  },
  {
    path: "/create-split-route",
    Component: CreateSplitRoute,
  },
  {
    path: "/split-route-management",
    Component: SplitRouteManagement,
  },
  {
    path: "/vehicle-insurance-limit",
    Component: VehicleInsuranceLimitList,
  },
];

export default function AppRoutes() {
  const location = useLocation();
  const { filters, dispatch } = useContext(UserContext);
  const { dispatch: lookUpDispatch } = useContext(LookUpContext);

  const { data: bagTypes } = useGetAllBagTypes();
  const { data: coinContainers } = useGetCoinContainers();
  const { data: currencyList } = useGetCurrenciesList();
  useEffect(() => {
    // This will run whenever the route changes
    const filterRoute = location.pathname.split("/")[1].replace(/-detail$/, "");
    const moduleArr = Object.keys(filters || {});
    const isSameModule = moduleArr.some((str) => str.includes(filterRoute));
    if (!isSameModule) {
      saveFilters(dispatch, {});
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (bagTypes) {
      setBagTypes(lookUpDispatch, bagTypes);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bagTypes]);

  useEffect(() => {
    if (coinContainers) {
      setCoinContainers(lookUpDispatch, coinContainers);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coinContainers]);

  useEffect(() => {
    if (currencyList) {
      setCurrencyList(lookUpDispatch, currencyList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currencyList]);

  return (
    <Routes>
      {routes.map(({ path, Component }) => (
        <Route key={path} element={<Component />} path={path} />
      ))}
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}
